import { QueryClient } from "react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      // cacheTime: 0, // Helps to debug without cache IF cacheTime per request isn't specified ! @Dev
      // staleTime: 0, // Helps to debug without cache IF staleTime per request isn't specified ! @Dev

      // Un-comment here to trace useQuery traffic ( saved cache post API calls )
      // onSuccess: (data: any) => {
      //   const queryState = queryClient.getQueryCache().findAll();
      //   queryState.forEach((query) => {
      //     console.log(
      //       "[QueryClient] onSuccess - keys :",
      //       query.queryKey,
      //       "Stored data :",
      //       data
      //     );
      //   });
      // },
      // onError: (data: any) => {
      //   const queryState = queryClient.getQueryCache().findAll();
      //   queryState.forEach((query) => {
      //     console.log(
      //       "[QueryClient] ERROR - keys :",
      //       query.queryKey,
      //       "Failed data :",
      //       data
      //     );
      //   });
      // },
    },
  },
});
